import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
    withdrawModalOpen: false,
    bankLinkModalOpen: false,
    depositModalOpen: false,
    pendingDepositAttributions: [],
    advisorAccounts: []
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}